import React from 'react';
import { ArrowRightIcon, UsersIcon, MessageCircleIcon, PresentationIcon, ZapIcon, BookOpenIcon, LayersIcon, MicIcon, UserIcon, GraduationCapIcon, BuildingIcon } from 'lucide-react';
import { PageTransition } from '../components/layout/PageTransition';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { DecorativeShape } from '../components/DecorativeShape';
import { Animate } from '../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
interface ChallengeCard {
  icon: React.ReactNode;
  accent: string;
  accentLight: string;
  accentText: string;
  borderColor: string;
  titleKey: string;
  subtitleKey: string;
  descKey: string;
  path: string;
}
interface WayCard {
  icon: React.ReactNode;
  lightColor: string;
  textColor: string;
  borderColor: string;
  titleKey: string;
  descKey: string;
  path: string;
}
export function Services() {
  const {
    t
  } = useLanguage();
  const ways: WayCard[] = [{
    icon: <UserIcon size={28} data-id="element-1199" data-mp="16mq6lf4lajex" />,
    lightColor: 'bg-coral/10',
    textColor: 'text-coral',
    borderColor: 'border-coral/20',
    titleKey: 'home.ways.coaching.title',
    descKey: 'home.ways.coaching.desc',
    path: '/services/coaching'
  }, {
    icon: <LayersIcon size={28} data-id="element-1200" data-mp="1kh0y247z0roo" />,
    lightColor: 'bg-teal/10',
    textColor: 'text-teal',
    borderColor: 'border-teal/20',
    titleKey: 'home.ways.facilitation.title',
    descKey: 'home.ways.facilitation.desc',
    path: '/services/meetings-and-facilitation'
  }, {
    icon: <GraduationCapIcon size={28} data-id="element-1201" data-mp="1zejjawlfwmrd" />,
    lightColor: 'bg-yellow-100',
    textColor: 'text-yellow-600',
    borderColor: 'border-yellow-200',
    titleKey: 'home.ways.training.title',
    descKey: 'home.ways.training.desc',
    path: '/services/courses'
  }, {
    icon: <BuildingIcon size={28} data-id="element-1202" data-mp="90aqohrt9tth" />,
    lightColor: 'bg-blue-50',
    textColor: 'text-blue-600',
    borderColor: 'border-blue-200',
    titleKey: 'home.ways.embedded.title',
    descKey: 'home.ways.embedded.desc',
    path: '/services/embedded-partner'
  }];
  const challenges: ChallengeCard[] = [{
    icon: <UsersIcon size={32} data-id="element-1203" data-mp="1le7rud29u4u6" />,
    accent: 'bg-coral',
    accentLight: 'bg-coral/10',
    accentText: 'text-coral',
    borderColor: 'border-coral/20',
    titleKey: 'services.challenge1Title',
    subtitleKey: 'services.challenge1Subtitle',
    descKey: 'services.challenge1Desc',
    path: '/services/new-to-leadership'
  }, {
    icon: <MessageCircleIcon size={32} data-id="element-1204" data-mp="2515fum6gj121" />,
    accent: 'bg-teal',
    accentLight: 'bg-teal/10',
    accentText: 'text-teal',
    borderColor: 'border-teal/20',
    titleKey: 'services.challenge2Title',
    subtitleKey: 'services.challenge2Subtitle',
    descKey: 'services.challenge2Desc',
    path: '/services/conflict-and-conversations'
  }, {
    icon: <PresentationIcon size={32} data-id="element-1205" data-mp="290ecpzwsnf1t" />,
    accent: 'bg-yellow-500',
    accentLight: 'bg-yellow-100',
    accentText: 'text-yellow-600',
    borderColor: 'border-yellow-200',
    titleKey: 'services.challenge3Title',
    subtitleKey: 'services.challenge3Subtitle',
    descKey: 'services.challenge3Desc',
    path: '/services/meetings-and-facilitation'
  }, {
    icon: <ZapIcon size={32} data-id="element-1206" data-mp="2nr0t0gq5i7ox" />,
    accent: 'bg-blue-600',
    accentLight: 'bg-blue-50',
    accentText: 'text-blue-600',
    borderColor: 'border-blue-200',
    titleKey: 'services.challenge4Title',
    subtitleKey: 'services.challenge4Subtitle',
    descKey: 'services.challenge4Desc',
    path: '/services/leading-in-complexity'
  }];
  const formats = [{
    icon: <BookOpenIcon size={28} data-id="element-1207" data-mp="24yput06fyxx5" />,
    color: 'bg-coral/10',
    iconColor: 'text-coral',
    titleKey: 'services.additional.courses.title',
    descKey: 'services.additional.courses.description',
    link: '/services/courses'
  }, {
    icon: <LayersIcon size={28} data-id="element-1208" data-mp="1nxbxdy4k09pf" />,
    color: 'bg-teal/10',
    iconColor: 'text-teal',
    titleKey: 'services.additional.workshops.title',
    descKey: 'services.additional.workshops.description',
    link: '/services/workshops'
  }, {
    icon: <MicIcon size={28} data-id="element-1209" data-mp="1e4wg7312zp5l" />,
    color: 'bg-yellow-100',
    iconColor: 'text-yellow-600',
    titleKey: 'services.additional.talks.title',
    descKey: 'services.additional.talks.description',
    link: '/services/talks'
  }];
  return <PageTransition data-id="element-1210" data-mp="106g93azb3wmx">
      <div className="pt-12 pb-24" data-id="element-1211" data-mp="105wua34ydod4">
        {/* Header */}
        <section className="text-center max-w-4xl mx-auto px-4 mb-20 relative" data-id="element-1212" data-mp="v7vbljbfvr26">
          <DecorativeShape type="square" color="bg-teal/10" className="top-0 right-0 w-32 h-32 rotate-12 -z-10" data-id="element-1213" data-mp="r72ygezg520m" />
          <Animate data-id="element-1214" data-mp="2plmqoycjf350">
            <h1 className="text-5xl md:text-6xl font-bold mb-4" data-id="element-1215" data-mp="2pk38v3b8gk14">
              {t('services.title')}{' '}
              <span className="text-coral" data-id="element-1216" data-mp="7d31akdwjz42">{t('services.titleHighlight')}</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1217" data-mp="7b8mzox4z58y">
              {t('services.subtitle')}
            </p>
          </Animate>
        </section>

        {/* Ways of working */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24" data-id="element-1218" data-mp="h58rppoia8h5">
          <Animate className="mb-10" data-id="element-1219" data-mp="l3y9rvkhoe74">
            <h2 className="text-2xl font-bold text-charcoal" data-id="element-1220" data-mp="3kjlbml7dyjnf">
              {t('home.ways.title')}
            </h2>
            <p className="text-gray-500 mt-1" data-id="element-1221" data-mp="3pi6aag6zov9r">{t('home.ways.subtitle')}</p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1222" data-mp="3tjrukmlusbtz">
            {ways.map((way, i) => <Animate key={i} delay={i * 0.08} data-id="element-1223" data-mp="2ei12kynhffm" data-mpi={i}>
                <Link to={way.path} className="block group h-full" data-id="element-1224" data-mp="2f9srkp4mt0m">
                  <Card className={`h-full p-6 border-2 ${way.borderColor} hover:shadow-md transition-all`} hoverEffect data-id="element-1225" data-mp="18t0vbei8ur6w">
                    <div className="flex items-start gap-4" data-id="element-1226" data-mp="39viglyun7et0">
                      <div className={`p-3 rounded-2xl ${way.lightColor} flex-shrink-0`} data-id="element-1227" data-mp="39y4mzv5sro9n">
                        <div className={way.textColor} data-id="element-1228" data-mp="35wrf7fj59b03">{way.icon}</div>
                      </div>
                      <div className="flex-1" data-id="element-1229" data-mp="3jsdce9zj713l">
                        <h3 className={`text-lg font-bold text-charcoal mb-2 group-hover:${way.textColor} transition-colors`} data-id="element-1230" data-mp="3ev3es71znj4o">
                          {t(way.titleKey)}
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed mb-3" data-id="element-1231" data-mp="2m7h2maep3667">
                          {t(way.descKey)}
                        </p>
                        <div className={`flex items-center ${way.textColor} text-sm font-bold`} data-id="element-1232" data-mp="30xoiqjh8cd3q">
                          {t('home.ways.learnMore')}
                          <ArrowRightIcon size={14} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1233" data-mp="28e98oc355ylc" />
                        </div>
                      </div>
                    </div>
                  </Card>
                </Link>
              </Animate>)}
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1234" data-mp="9z21sqwtr76z">
          <div className="border-t border-gray-100" data-id="element-1235" data-mp="dyaxi1bfdf56" />
        </div>

        {/* Challenge cards */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24" data-id="element-1236" data-mp="11oeys21552t0">
          <Animate className="mb-10" data-id="element-1237" data-mp="16nhqylw0vejk">
            <h2 className="text-2xl font-bold text-charcoal" data-id="element-1238" data-mp="16mgi8o2hb450">
              {t('services.challengesTitle')}
            </h2>
            <p className="text-gray-500 mt-1" data-id="element-1239" data-mp="sq2yt9edwsnw">{t('services.challengesSubtitle')}</p>
          </Animate>

          <div className="space-y-6" data-id="element-1240" data-mp="xp63gsqgcwvc">
            {challenges.map((c, index) => <Animate key={index} delay={index * 0.08} data-id="element-1241" data-mp="3dcwdrsjojfpi" data-mpi={index}>
                <Link to={c.path} className="block group" data-id="element-1242" data-mp="3idkfp99g5gyi">
                  <Card className={`p-0 overflow-hidden border-2 ${c.borderColor} hover:shadow-lg transition-shadow`} data-id="element-1243" data-mp="3iaxwudh3vf0z">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-0" data-id="element-1244" data-mp="8vle7nhl3i88">
                      <div className={`md:col-span-2 ${c.accentLight} p-8 flex flex-col justify-center items-center text-center`} data-id="element-1245" data-mp="3wi7zzpvb5yo">
                        <div className={`w-16 h-16 rounded-full ${c.accent} text-white flex items-center justify-center shadow-md mb-3`} data-id="element-1246" data-mp="3v55tqgs0sv6r">
                          {c.icon}
                        </div>
                        <p className={`text-sm font-bold ${c.accentText} uppercase tracking-wide`} data-id="element-1247" data-mp="rne7lj0kf5gh">
                          {t(c.subtitleKey)}
                        </p>
                      </div>
                      <div className="md:col-span-10 p-8 flex items-center justify-between bg-white gap-6" data-id="element-1248" data-mp="hwjhu4o41nqa">
                        <div className="flex-1" data-id="element-1249" data-mp="1fdrtersk482m">
                          <h3 className={`text-2xl font-bold mb-3 text-charcoal group-hover:${c.accentText} transition-colors`} data-id="element-1250" data-mp="1al8glx1p1gyv">
                            {t(c.titleKey)}
                          </h3>
                          <p className="text-gray-600 leading-relaxed max-w-2xl" data-id="element-1251" data-mp="1mv6f4yyeq0jw">
                            {t(c.descKey)}
                          </p>
                        </div>
                        <div className={`flex-shrink-0 ${c.accentText} group-hover:translate-x-1 transition-transform`} data-id="element-1252" data-mp="1wtvuol2tz8wz">
                          <ArrowRightIcon size={28} data-id="element-1253" data-mp="20upm3ofhf5um" />
                        </div>
                      </div>
                    </div>
                  </Card>
                </Link>
              </Animate>)}
          </div>
        </section>

        {/* Formats section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1254" data-mp="2fl6kt00qfhnt">
          <Animate className="mb-10" data-id="element-1255" data-mp="2fmhokzu6gpex">
            <h2 className="text-2xl font-bold text-charcoal" data-id="element-1256" data-mp="2kkj97p794wsi">
              {t('services.formatsTitle')}
            </h2>
            <p className="text-gray-500 mt-1" data-id="element-1257" data-mp="2olv0dz5rxq2t">{t('services.formatsSubtitle')}</p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1258" data-mp="2eo4jpel3r0ch">
            {formats.map((f, i) => <Animate key={i} delay={i * 0.1} data-id="element-1259" data-mp="2jm64q52399ql" data-mpi={i}>
                <Card className="p-8 h-full border-2 border-gray-100 hover:shadow-md transition-shadow" data-id="element-1260" data-mp="2okzdjk6fkckf">
                  <div className={`p-3 rounded-2xl ${f.color} w-fit mb-4`} data-id="element-1261" data-mp="2tby031i0i6w4">
                    <div className={f.iconColor} data-id="element-1262" data-mp="2yaj1h4902wm5">{f.icon}</div>
                  </div>
                  <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-1263" data-mp="2ycvfj6bn0mtx">
                    {t(f.titleKey)}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1264" data-mp="37apaodxo1afi">
                    {t(f.descKey)}
                  </p>
                  <Link to={f.link} data-id="element-1265" data-mp="3c98tw6kvk846">
                    <Button variant="outline" rightIcon={<ArrowRightIcon size={16} data-id="element-1267" data-mp="1cxpmvxj4t9x5" />} data-id="element-1266" data-mp="3c87ig0zy5jlx">
                      {t('services.seeMore')}
                    </Button>
                  </Link>
                </Card>
              </Animate>)}
          </div>
        </section>
      </div>
    </PageTransition>;
}